import { FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewContainerRef } from '@angular/core';

import { Sizes } from '../../../shared/enums/size.enum';
import { Field } from '../../../core/field/abstract/field';


@Component({
    selector: 'odd-input',
    templateUrl: './input.component.html',
})

export class InputComponent extends Field implements OnInit, OnChanges {
    public sizeIcon: string;
    public isSuccess: boolean;

    @Input() public value: string;
    @Input() public readonly size: Sizes;
    @Input() public readonly name: string;
    @Input() public readonly label: string;
    @Input() public readonly iconLeft: string;
    @Input() public readonly iconRight: string;
    @Input() public readonly isLoading: boolean;
    @Input() public readonly placeholder: string;
    @Input() public readonly forceError: boolean;
    @Input() public readonly isDisabled: boolean;
    @Input() public readonly formGroup: FormGroup;
    @Input() public readonly type: string = 'text';

    @Output('onClickIconRight') public readonly fireClickIconRight: EventEmitter<void> = new EventEmitter<void>();


    constructor(private readonly viewRef: ViewContainerRef) {
        super(viewRef);
    }

    public ngOnInit(): void {
        if (!this.formGroup) {
            super.ngOnInit();
        } else {
            this.form = this.formGroup;
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const { forceError } = changes;

        if (forceError && !forceError.firstChange && forceError.currentValue) {
            this.form.controls[this.name].markAsDirty();
        }
    }

    public get hasError() {
        return !!this.form.get(this.name).errors && !!Object.keys(this.form.get(this.name).errors).length;
    }

    public onBlur() {
        this.isSuccess = !this.hasError;
    }

    public onFocus() {
        this.isSuccess = false;
    }
}
